import "./SwitchingDataEntryWarningModal.css";

import { FormEvent } from "react";

import { ActionButtons } from "../../forms";
import { Column, Row } from "../../layout";
import { Modal } from "../Modal";
import { SwitchingDataEntryWarningModalProps } from "./models";

export const SwitchingDataEntryWarningModal = ({
  show,
  currentMethod,
  projectCount,
  onDiscardAndSwitch,
  onKeepEntries,
}: SwitchingDataEntryWarningModalProps): JSX.Element => {
  const isLeavingUpload = currentMethod === "upload";

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
    onDiscardAndSwitch();
  };

  return (
    <Modal
      className="SwitchingDataEntryWarningModal"
      show={show}
      title={isLeavingUpload ? "Switch to manual entry" : "Switch to file upload"}
      onClose={onKeepEntries}
      onBackdrop={onKeepEntries}
    >
      <form onSubmit={handleSubmit}>
        <div className="SwitchingDataEntryWarningModal_content">
          {isLeavingUpload ? (
            <p className="body2">
              You&apos;ve already uploaded a file with projects. Switching to manual entry will discard everything
              you&apos;ve added on this page, this can&apos;t be undone.
            </p>
          ) : (
            <p className="body2">
              You&apos;ve already entered details for {projectCount} {projectCount === 1 ? "project" : "projects"}{" "}
              manually. Switching to file upload will discard everything you&apos;ve entered on this page, this
              can&apos;t be undone.
            </p>
          )}
          <Row justify="center">
            <Column span={8} hasNoPadding>
              <ActionButtons
                fullWidth
                submitButtonLabel="Discard and switch"
                cancelButtonLabel={isLeavingUpload ? "Keep uploaded entries" : "Keep manual entries"}
                onCancel={onKeepEntries}
              />
            </Column>
          </Row>
        </div>
      </form>
    </Modal>
  );
};
